import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '../translations/dealer';

export const DOCUMENT_LANG_STORAGE_KEY = 'smodDealerLang';

/** Map company.country (any common spelling) to a dealer UI language. */
export function languageFromCountry(country) {
  const c = (country || '').trim().toLowerCase();
  if (c === 'pl' || c === 'poland' || c === 'polska') return 'pl';
  if (c === 'hu' || c === 'hungary' || c === 'magyarország') return 'hu';
  if (c === 'sk' || c === 'slovakia' || c === 'slovensko' || c === 'slovak republic') return 'sk';
  if (c === 'ro' || c === 'romania' || c === 'românia') return 'ro';
  return DEFAULT_LANGUAGE;
}

export function applyDocumentLanguage(lang) {
  const effective = lang && SUPPORTED_LANGUAGES.includes(lang) ? lang : DEFAULT_LANGUAGE;
  const html = document.documentElement;
  html.lang = effective;
  html.setAttribute('lang', effective);
  html.setAttribute('translate', 'no');
  html.classList.add('notranslate');
  try {
    localStorage.setItem(DOCUMENT_LANG_STORAGE_KEY, effective);
  } catch (e) {
    /* ignore quota / private mode */
  }
}
